<template>
    <div>
        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Variant></NavBar_Variant>

            <v-container style="width:100%;">
                <v-row>
                    <v-col cols="12" md="12" lg="12" xl="12" style="text-align:center;">
                        <v-card v-if="'nearby_mutations' in item.onkopus_aggregator.aggregated_evidence_data">
                            <h5 style="text-align:left;">Nearby Biomarkers ({{ Object.keys(item.onkopus_aggregator.aggregated_evidence_data.nearby_mutations).length }})</h5>

                            <v-table>
                            <tbody>
                                <tr v-for="key in Object.keys(item.onkopus_aggregator.aggregated_evidence_data.nearby_mutations)">
                                    <td style="text-align:left;">
                                        <router-link :to="'/show-variant-details-q/'+getBiomarkerURI(key)"
                                         style="text-decoration:none;color:inherit;" >
                                            {{ key }}
                                            ({{ item.onkopus_aggregator.aggregated_evidence_data.nearby_mutations[key].length }})
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </v-table>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

        </span>
    </div>
</template>
<script>
import active_variants from "@/methods/active_variants";
import NavBar_Variant from '@/components/navbars/NavBar_Variant';

export default {
    name: 'VariantNearbyTreatments',
    props: {
    },
    components: {
        NavBar_Variant,
    },
    data: function() {
        return {
            isLoading: false,
            fullPage: true,
        }
    },
    methods: {
        getBiomarkerURI(biomarker_id) {
            biomarker_id = biomarker_id.replace(" ",":")
            return biomarker_id
        },
    },
    created: async function() {
        //alert(this.$route.fullPath)

        this.isLoading=true
        await active_variants.loadActiveBiomarker(this.$route.params.id)
        this.isLoading=false

    }
}

</script>
<style>
</style>
